export default {
  'memberAreaJourney.title': 'ประวัติสมาชิก',
  'memberAreaJourney.period': 'ระยะเวลา',
  'memberAreaJourney.no_records': 'ยังไม่มีบันทึกประวัติสมาชิก',
  'memberAreaJourney.reason_1': 'สมาชิกใหม่',
  'memberAreaJourney.reason_2': 'อัปเกรดระดับการใช้จ่าย',
  'memberAreaJourney.reason_3': 'อัปเกรดระดับด้วยตนเอง',
  'memberAreaJourney.reason_4': 'ลดระดับด้วยตนเอง',
  'memberAreaJourney.reason_5': 'ลดระดับเนื่องจากหมดอายุ',
  'memberAreaJourney.reason_6': 'ต่ออายุสถานะหลังหมดอายุ',
  'memberAreaJourney.reason_7': 'ลดระดับเนื่องจากยกเลิกรายการ',
  'memberAreaJourney.reason_8': 'ลดระดับอัตโนมัติเมื่อหมดอายุ',
  'memberAreaJourney.reason_9': 'ต่ออายุอัตโนมัติเมื่อหมดอายุ',
  'memberAreaJourney.reason_10': 'เปลี่ยนระบบเป็นรูปแบบสมาชิกใหม่',
} as Record<string, string>;
